import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/home/Home";
import Contact from "./components/contact/Contact";
import About from "./components/about/About";
import Gowns from "./components/pages/Gowns.jsx";
import ViewProduct from "./components/pages/ViewProduct";
import SizeChart from "./components/SizeChart/SizeChart.jsx";

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="/about" element={<About />} />
				<Route path="/gowns/:year" element={<Gowns />} />
				<Route path="/Gowns/id/:style" element={<ViewProduct />} />
				<Route
	path="/size-chart/:category"
	element={<SizeChart />}
/>
			</Routes>
		</Router>
	);
}

export default App;
